import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import GeneralContainer from '../components/GeneralContainer'
import ExclusiveContainer from '../components/ExclusiveContainer'

export default function N25_10_03() {
  return (
    <NoteContainer date={'03/10/2025'} version="20.8.0">
      <VStack w="full">
        <GeneralContainer>
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Correção de alerta na edição da questão</TaskTitle>
                <TaskBreadcrumb>Formulários/ questões</TaskBreadcrumb>
                <TaskDescription>Correção do texto de alerta quando atualizado algum campo na questão</TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </GeneralContainer>
        <ModuleContainer moduleName="ASSESSMENTS_AND_RESEARCH">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle important={true}>
                  Perguntas deletadas sendo consideradas nos relatórios da pesquisa
                </TaskTitle>
                <TaskBreadcrumb>Pesquisas/ Perfil da pesquisa / Relatórios</TaskBreadcrumb>
                <TaskDescription>
                  Agora, as perguntas deletadas de um formulário estão sendo consideradas em TODOS os relatórios
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Perguntas deletadas sendo consideradas na planilha</TaskTitle>
                <TaskBreadcrumb>Pesquisas/ Perfil da pesquisa / Formulários respondidos</TaskBreadcrumb>
                <TaskDescription>
                  Agora, as perguntas deletadas de um formulário estão sendo consideradas no arquivo gerado pela
                  interface
                </TaskDescription>
              </Box>
            </CategoryContainer>
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção nos relatórios da pesquisa</TaskTitle>
                <TaskBreadcrumb>Pesquisas/ Perfil da pesquisa/ Relatórios</TaskBreadcrumb>
                <TaskDescription>
                  Correção do problema do carregamento infinito ao abrir os relatórios da pesquisa
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="CITIZEN_PROFILE">
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <ExclusiveContainer institutions={['agsus']} category="ADJUSTMENTS">
                <Box>
                  <TaskTitle>Valor padrão na consulta do holerite</TaskTitle>
                  <TaskBreadcrumb>Cidadãos/ Perfil do cidadão/ Ações</TaskBreadcrumb>
                  <TaskDescription>Todos os campos da consulta do SIP agoram possuem um valor inicial</TaskDescription>
                </Box>
              </ExclusiveContainer>
              <Box>
                <TaskTitle>Auxílio visual no filtro rápido</TaskTitle>
                <TaskBreadcrumb>Cidadãos</TaskBreadcrumb>
                <TaskDescription>
                  Adicionado botão de ajuda para informar quais campos serão filtrados no filtro rápido
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Nome do cidadão com marcação</TaskTitle>
                <TaskBreadcrumb>Cidadãos</TaskBreadcrumb>
                <TaskDescription>
                  Quando utilizado o filtro rápido, agora o nome do cidadão terá uma marcação caso seja o mesmo nome
                  filtrado
                </TaskDescription>
              </Box>
            </CategoryContainer>
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção de filtros</TaskTitle>
                <TaskBreadcrumb>Cidadãos</TaskBreadcrumb>
                <TaskDescription>Correção do filtro geral da página</TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="REGULATION">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle important={true}>Dashboard: Extratos da solicitação</TaskTitle>
                <TaskBreadcrumb>Regulação/ Dashboard Extratos da solicitação</TaskBreadcrumb>
                <TaskDescription>
                  Novo dashboard para visualizar as solicitações por mês na visão do profissional que as solicitou
                </TaskDescription>
              </Box>
            </CategoryContainer>
            <ExclusiveContainer institutions={['agsus']} category="FIX">
              <CategoryContainer category="FIX">
                <Box>
                  <TaskTitle>Correção na nomenclatura do serviço CASAI</TaskTitle>
                  <TaskBreadcrumb>Regulação / Painel da regulação</TaskBreadcrumb>
                  <TaskDescription>
                    Correção para mostrar o nome do serviço da maneira certa ao invés do nome do solicitante
                  </TaskDescription>
                </Box>
              </CategoryContainer>
            </ExclusiveContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
